export default "__VITE_ASSET__624d638c__"